import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  /* Course Details */
  .course-details-area {
    padding: 70px 0 78px;
    .course-details-top {
      .heading {
        h4 {
          color: ${colors.black1};
          font-weight: 600;
          line-height: 35px;
          margin-bottom: 25px;

          @media (max-width: 575px) {
            font-size: 20px;
          }
        }
      }
      .course-top-overview {
        margin-bottom: 25px;
        .overviews {
          .author {
            margin-right: 20px;
            padding-right: 20px;
            margin-top: -3px;
            border-right: 1px solid ${colors.border3};
            img {
              float: left;
              max-width: 50px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .author-name {
              float: left;
              margin-top: 3px;
              h6 {
                color: ${colors.black2};
                font-weight: 600;
                text-transform: uppercase;
                margin-bottom: 5px;

                @media (max-width: 767px) {
                  font-size: 14px;
                }
              }
              p {
                font-size: 15px;
                color: ${colors.text3};
                font-weight: 500;

                @media (max-width: 767px) {
                  font-size: 14px;
                }
              }
            }
          }

          .category {
            margin-right: 20px;
            padding-right: 20px;
            border-right: 1px solid ${colors.border3};
            h6 {
              color: ${colors.black2};
              font-weight: 600;
              text-transform: uppercase;
              margin-bottom: 5px;

              @media (max-width: 767px) {
                font-size: 14px;
              }
            }
            p {
              font-size: 15px;
              color: ${colors.text3};
              font-weight: 500;

              @media (max-width: 767px) {
                font-size: 14px;
              }
            }
          }

          .rating {
            margin-right: 20px;
            padding-right: 20px;
            border-right: 1px solid ${colors.border3};
            h6 {
              color: ${colors.black2};
              font-weight: 600;
              text-transform: uppercase;
              margin-bottom: 5px;

              @media (max-width: 767px) {
                font-size: 14px;
              }
            }
            ul {
              li {
                margin-right: 1px;
                i {
                  font-size: 16px;
                  color: ${colors.yellow};
                }
                &:last-child {
                  font-size: 15px;
                  color: ${colors.text3};
                  font-weight: 500;
                  margin-left: 5px;

                  @media (max-width: 767px) {
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .price {
            h6 {
              color: ${colors.black2};
              font-weight: 600;
              text-transform: uppercase;
              margin-bottom: 5px;

              @media (max-width: 767px) {
                font-size: 14px;
              }
            }
            p {
              font-size: 15px;
              color: ${colors.text3};
              font-weight: 500;

              @media (max-width: 767px) {
                font-size: 14px;
              }
            }
          }
        }

        @media (max-width: 480px) {
          display: none;
        }
      }
      .course-details-banner {
        margin-bottom: 40px;
        position: relative;
        max-width: 825px;
        aspect-ratio: 825 / 498;

        img {
          width: 100%;
          border-radius: 5px;
        }
      }

      @media (max-width: 767px) {
        margin-bottom: 40px;
      }
    }

    @media (max-width: 767px) {
      padding: 20px 0 5px;
    }
  }
`;

export const Subscription = styled.div`
  border: 2px solid ${colors.blue};
  border-radius: 5px;
  margin-bottom: 40px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);

  button.enroll-btn {
    font-size: 16px;
    color: #fff;
    background: ${colors.grBg};
    display: inline-block;
    width: 230px;
    height: 50px;
    font-weight: 500;
    border: none;
    padding: 9px;
    border-radius: 5px;
    &:hover {
      background: ${colors.grBg2};
    }

    @media (max-width: 575px) {
      font-size: 14px;
    }
  }

  h2 {
    font-weight: 600;
  }

  section {
    padding: 20px;
  }

  section:first-child {
    background-color: ${colors.blue};
    color: #333;
    span {
      display: block;
      margin-top: 15px;
      font-size: 16px;
      font-weight: 500;
    }
  }

  section:last-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: ${colors.text2};

    @media screen and (max-width: 991px) {
      gap: 10px;
      flex-direction: column;
    }
  }
`;

export const Certification = styled.div`
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 15px 20px 20px;
  margin-bottom: 30px;

  div {
    position: relative;
    max-width: 211px;
    aspect-ratio: 211 / 152;
    margin: auto;

    img {
      width: 100%;
    }
  }

  h5.title {
    color: ${colors.black1};
    font-weight: 600;
    padding-bottom: 10px;
    margin-bottom: 20px;
    position: relative;
    &:before {
      position: absolute;
      content: '';
      background: ${colors.blue};
      width: 50px;
      height: 2px;
      bottom: 0;
      left: 0;
    }

    @media (max-width: 575px) {
      font-size: 17px;
    }
  }

  span {
    font-size: 15px;
    color: ${colors.text2};
    display: block;
    margin-top: 10px;
  }
`;
